import { ALPHA_2_ISO_3166, SALUTATIONS } from 'cpool-constants';
import { z } from 'zod';

export const schemaRawSchufaRequest = z.object({
    personendaten: z.object({
        anrede: z.nativeEnum(SALUTATIONS),
        geburtsdatum: z.coerce.date(),
        geburtsort: z
            .string()
            .optional()
            .transform((val) => (val ? val.substring(0, 24) : val)),
        nachname: z.string(),
        vorname: z.string(),
    }),
    wohnsituation: z.object({
        anschrift: z.object({
            hausnummer: z.string(),
            land: z.nativeEnum(ALPHA_2_ISO_3166).optional(),
            ort: z.string(),
            plz: z.string(),
            strasse: z.string(),
        }),
    }),
});

export type SchemaRawSchufaRequest = z.infer<typeof schemaRawSchufaRequest>;
